/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Locality_SetInputs */

const cs_requirements_locality_set = /** @type {(inputs: Requirements_Locality_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalita vybrána`)
};

const en_requirements_locality_set = /** @type {(inputs: Requirements_Locality_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locality selected`)
};

/**
* | output |
* | --- |
* | "Locality selected" |
*
* @param {Requirements_Locality_SetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_locality_set = /** @type {((inputs?: Requirements_Locality_SetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Locality_SetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_locality_set(inputs)
	return cs_requirements_locality_set(inputs)
});